// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Sans:ital,wght@0,400..700;1,400..700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signInContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.signInText2 {
  font-family: "Poppins", sans-serif;
  font-weight: 400px;
  font-size: 16px;
  line-height: 24px;
}
.parentInputContainer{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 28px;
  margin-top: 56px;
}
/* .signInInputContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
} */
.signInLabel {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}
/* .inputWrapper {
  position: relative;
} */
/* .signInInput {
  all: unset;
  background-color: #1a1a1a;
  width: 31.51vw;
  height: 48px;
  border-radius: 52px;
  box-sizing: border-box;
  padding-left: 16px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 500;
} */
/* .errorTooltip {
  position: absolute;
  top: 100%;
  left: 0;
  color: #C15F5F;
  font-size: 12px;
  margin-top: 4px;
  white-space: nowrap;
  z-index: 10;
  pointer-events: none;
} */
.passwordInputWrapper {
  position: relative;
}
.eyeIcon {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #7A7A7A;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  transition: color 0.2s ease;
  z-index: 10;
}

.passwordToolTip{
  color: #C15F5F;
  font-size: 12px;
  white-space: nowrap;
  line-height: 12px;
}
.forgetPasswordText {
  font-family: "Inter", sans-serif;
  color: #48d1cc;
  font-size: 12px;
  line-height: 12px;
  text-align: right;
  width: 100%;
  cursor: pointer;
  display: inline;
}
.signInButtonContainer{
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 16px;
}

.signInDividerContainer{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 32px;
}
.signDivider1{
  width: 175px;
  height: 1px;
  background: linear-gradient(to right,rgba(255, 255, 255, 0), #BEBEBE );
}
.signDivider2{
  width: 175px;
  height: 1px;
  background: linear-gradient(to right,#BEBEBE, rgba(255, 255, 255, 0));
}
.signInOptionsContainer{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  margin-top: 20px;
  cursor: pointer;
}
.optionIconContainer{
  background-color: white;
  height: 52px;
  width: 52px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.signUpContainer{
  margin-top: 30px;
}
.signUpText1{
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}
.signUpText2{
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #48d1cc;
  cursor: pointer;
}
.appAvailableFor {
  margin-top: 30px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.appAvailableForText {
  font-family: "Instrument Sans", sans-serif;
  font-size: 16px;
  color: white;
  font-weight: 500;
  line-height: 24px;
}
.iconContainer{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0e0e10;
  border: 1px solid rgba(134, 134, 134, 0.16);
  border-radius: 100px;
}
.iconContainer2 {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
}
.smallIcon {
  height: 28px;
  width: 28px;
  cursor: pointer;
}

.verticalLine {
  width: 1px;
  height: 20px;
  background-color: rgba(134, 134, 134, 0.16);
}


.btnContainer {
  cursor: pointer;
}

.btnContainer:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.checkboxContainer {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.rememberMeCheckbox {
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  border: 1.5px solid rgba(255, 255, 255, 0.28);
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.05);
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.rememberMeCheckbox:hover {
  border-color: rgba(255, 255, 255, 0.5);
}

.rememberMeCheckbox:checked {
  background-color: #48d1cc;
  border-color: #48d1cc;
}

.rememberMeCheckbox:checked::after {
  content: "✓";
  position: absolute;
  color: #061c1b;
  font-size: 13px;
  font-weight: 900;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.forgetPasswordContainer {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  flex-direction: row !important;
  width: 100%;
  margin-top: 14px;
}

.forgetPasswordText {
  font-family: "Inter", sans-serif;
  color: #48d1cc;
  font-size: 13.5px;
  font-weight: 500;
  line-height: 16px;
  text-align: right;
  cursor: pointer;
  transition: opacity 0.2s ease, -webkit-text-decoration 0.2s ease;
  transition: opacity 0.2s ease, text-decoration 0.2s ease;
  transition: opacity 0.2s ease, text-decoration 0.2s ease, -webkit-text-decoration 0.2s ease;
}

.forgetPasswordText:hover {
  text-decoration: underline;
  opacity: 0.9;
}

@media (max-width: 1440px) {
  .parentInputContainer {
    gap: 22px;
    margin-top: 36px;
  }
}

@media (max-width: 1024px) {
  .parentInputContainer {
    gap: 18px;
    margin-top: 28px;
  }
}

.sc-overlay {
  background-color: rgba(7, 20, 20, 0.5) !important; /* 50% transparent */
  backdrop-filter: blur(10px) !important;
}
.sc-button-container {
  margin-top: 10px !important;
}
.sc-title{
  color: white !important;
}

.sc-captcha-text-container {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/SignInFlow/SignIn/SignIn.css"],"names":[],"mappings":"AAIA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;;;;GAIG;AACH;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;GAEG;AACH;;;;;;;;;;;GAWG;AACH;;;;;;;;;;GAUG;AACH;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,sEAAsE;AACxE;AACA;EACE,YAAY;EACZ,WAAW;EACX,qEAAqE;AACvE;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,0CAA0C;EAC1C,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,2CAA2C;AAC7C;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gEAAwD;EAAxD,wDAAwD;EAAxD,2FAAwD;AAC1D;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE;IACE,SAAS;IACT,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;IACT,gBAAgB;EAClB;AACF;;AAEA;EACE,iDAAiD,EAAE,oBAAoB;EACvE,sCAAsC;AACxC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Instrument+Sans:ital,wght@0,400..700;1,400..700&display=swap\");\n\n.signInContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.signInText2 {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.parentInputContainer{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 28px;\n  margin-top: 56px;\n}\n/* .signInInputContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n} */\n.signInLabel {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n}\n/* .inputWrapper {\n  position: relative;\n} */\n/* .signInInput {\n  all: unset;\n  background-color: #1a1a1a;\n  width: 31.51vw;\n  height: 48px;\n  border-radius: 52px;\n  box-sizing: border-box;\n  padding-left: 16px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n} */\n/* .errorTooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  color: #C15F5F;\n  font-size: 12px;\n  margin-top: 4px;\n  white-space: nowrap;\n  z-index: 10;\n  pointer-events: none;\n} */\n.passwordInputWrapper {\n  position: relative;\n}\n.eyeIcon {\n  position: absolute;\n  top: 50%;\n  right: 16px;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #7A7A7A;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  transition: color 0.2s ease;\n  z-index: 10;\n}\n\n.passwordToolTip{\n  color: #C15F5F;\n  font-size: 12px;\n  white-space: nowrap;\n  line-height: 12px;\n}\n.forgetPasswordText {\n  font-family: \"Inter\", sans-serif;\n  color: #48d1cc;\n  font-size: 12px;\n  line-height: 12px;\n  text-align: right;\n  width: 100%;\n  cursor: pointer;\n  display: inline;\n}\n.signInButtonContainer{\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: 16px;\n}\n\n.signInDividerContainer{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n  margin-top: 32px;\n}\n.signDivider1{\n  width: 175px;\n  height: 1px;\n  background: linear-gradient(to right,rgba(255, 255, 255, 0), #BEBEBE );\n}\n.signDivider2{\n  width: 175px;\n  height: 1px;\n  background: linear-gradient(to right,#BEBEBE, rgba(255, 255, 255, 0));\n}\n.signInOptionsContainer{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 32px;\n  margin-top: 20px;\n  cursor: pointer;\n}\n.optionIconContainer{\n  background-color: white;\n  height: 52px;\n  width: 52px;\n  border-radius: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.signUpContainer{\n  margin-top: 30px;\n}\n.signUpText1{\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n}\n.signUpText2{\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n  color: #48d1cc;\n  cursor: pointer;\n}\n.appAvailableFor {\n  margin-top: 30px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n.appAvailableForText {\n  font-family: \"Instrument Sans\", sans-serif;\n  font-size: 16px;\n  color: white;\n  font-weight: 500;\n  line-height: 24px;\n}\n.iconContainer{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #0e0e10;\n  border: 1px solid rgba(134, 134, 134, 0.16);\n  border-radius: 100px;\n}\n.iconContainer2 {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n}\n.smallIcon {\n  height: 28px;\n  width: 28px;\n  cursor: pointer;\n}\n\n.verticalLine {\n  width: 1px;\n  height: 20px;\n  background-color: rgba(134, 134, 134, 0.16);\n}\n\n\n.btnContainer {\n  cursor: pointer;\n}\n\n.btnContainer:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n.checkboxContainer {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.rememberMeCheckbox {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 18px;\n  height: 18px;\n  border: 1.5px solid rgba(255, 255, 255, 0.28);\n  border-radius: 5px;\n  background-color: rgba(255, 255, 255, 0.05);\n  cursor: pointer;\n  position: relative;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.rememberMeCheckbox:hover {\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.rememberMeCheckbox:checked {\n  background-color: #48d1cc;\n  border-color: #48d1cc;\n}\n\n.rememberMeCheckbox:checked::after {\n  content: \"✓\";\n  position: absolute;\n  color: #061c1b;\n  font-size: 13px;\n  font-weight: 900;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.forgetPasswordContainer {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  flex-direction: row !important;\n  width: 100%;\n  margin-top: 14px;\n}\n\n.forgetPasswordText {\n  font-family: \"Inter\", sans-serif;\n  color: #48d1cc;\n  font-size: 13.5px;\n  font-weight: 500;\n  line-height: 16px;\n  text-align: right;\n  cursor: pointer;\n  transition: opacity 0.2s ease, text-decoration 0.2s ease;\n}\n\n.forgetPasswordText:hover {\n  text-decoration: underline;\n  opacity: 0.9;\n}\n\n@media (max-width: 1440px) {\n  .parentInputContainer {\n    gap: 22px;\n    margin-top: 36px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .parentInputContainer {\n    gap: 18px;\n    margin-top: 28px;\n  }\n}\n\n.sc-overlay {\n  background-color: rgba(7, 20, 20, 0.5) !important; /* 50% transparent */\n  backdrop-filter: blur(10px) !important;\n}\n.sc-button-container {\n  margin-top: 10px !important;\n}\n.sc-title{\n  color: white !important;\n}\n\n.sc-captcha-text-container {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
